import React, { Component } from 'react';
import {
  TableCell,
  TableFooter,
  TableRow,
  Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import i18n from '../../i18n';

class EcommTableFooter extends Component {
  render() {
    const { getNow } = this.props;
    return (
      <TableFooter>
        <TableRow>
          <TableCell colSpan={2}>
            <Typography>
              {`${i18n.t('location:dataCurrent')} ${getNow()}`}
            </Typography>
          </TableCell>
        </TableRow>
      </TableFooter>
    )
  }
}

EcommTableFooter.propTypes = {
  getNow: PropTypes.func.isRequired,
}

export default EcommTableFooter
